import '../../monitoring/filters/grouped_elements/grouped_elements_filter_view.js.coffee'

class Customer.ResponseTemplateIntelligentTagsView extends Monitoring.Views.SocialContents.Filters.GroupedElementsFilterView
  template: JST['backbone/templates/customer/filters/tags_filter']
  selectAll: true
  alias: 'Intelligent Tag'
  className: 'tag-filter'

  initialize: (@options = {}) ->
    @intelligentTags = @options.intelligentTags || {}
    @hiddenTags = @options.hiddenTags || {}
    @groups_logic = @getGroupsLogic()
    @possible_elements = @initilizeElements()
    @applied_elements = @initilizeElements()
    @useCustomValues = @options.useCustomValues || false

    @tagsByClientCode = _.reduce(@options.tagsByClientCode,
      (memo, obj) -> memo[obj['code']] = obj.description; memo,
      {})
    terms = _.map(_.clone(@options.tagsByClientCode), (obj) -> obj.term = obj.code; obj)
    @terms = _.sortBy(terms, (term) => @getDescription(term).toLowerCase())
    @applyButtonClicked = false

  getGroupsLogic: ->
    'first_group_elements':    @intelligentTags['main_tags_logic'],
    'second_group_elements':   @intelligentTags['secondary_tags_logic'],
    'excluded_group_elements': @intelligentTags['excluded_tags_logic']

  getGroupsElements: ->
    first_group_elements: @withPrefix('main_tags')
    second_group_elements: @withPrefix('secondary_tags')
    excluded_group_elements: @withPrefix('excluded_tags')

  viewFor: (viewId) =>
    new Monitoring.Views.SocialContents.Filters.TagsFilterGroupView(@optionsFor(viewId))

  optionsFor: (viewID) =>
    options = super(viewID)
    options['includeAlternativeTaxonomies'] = false
    options

  titles: ->
    first_group_elements: I18n.t('monitoring.taxonomy.first_group_elements')
    second_group_elements: I18n.t('monitoring.taxonomy.second_group_elements')
    excluded_group_elements: I18n.t('monitoring.taxonomy.excluded_group_elements')

  getValues: ->
    {
      main_tags: _.pluck(@firstGroupView.appliedElements, 'term'),
      secondary_tags: _.pluck(@secondGroupView.appliedElements, 'term'),
      excluded_tags: _.pluck(@excludedGroupView.appliedElements, 'term'),
      main_tags_logic: @firstGroupView.logic,
      secondary_tags_logic: @secondGroupView.logic,
      excluded_tags_logic: @excludedGroupView.logic
    }

  _determineAppliedElements: (group) ->
    @intelligentTags[group]

  _generateAllElements: (terms)->
    tags = []
    for term, description of @tagsByClientCode
      facet = _.find(terms, (node) -> node.term == term)
      if facet
        count = facet.count
      else
        count = 0
      hidden = !!@hiddenTags[term]
      tags.push({ term: term, description: description, count: count , hidden: hidden , custom: false}) unless hidden
    return tags

  getName: ->
    'tags'

  canFilterOnlyPresent: ->
    false

  _applyFilter: ->
    @onApply()
    @applyButtonClicked = true

  _closeModal: ->

  clearIfCanceled: =>
    @render() unless @applyButtonClicked
    @applyButtonClicked = false

  _noValuesDescription: ->
    I18n.t('customer.dashboard.filters.creation.tags.no_tags')

  _allValuesDescription: ->
    I18n.t('customer.dashboard.filters.creation.tags.any_tag')

  _addCustomValues: (terms) ->
    if @useCustomValues
      super(terms)
